import { useConfiguratorSide } from '@/app/store/configurator/hooks/use-configurator-side';
import { EditorSide } from '@/shared/types/configurator';
import { FC } from 'react';
import { EditorWrapper } from '../editor-wrapper/editor-wrapper';
import { FrontEditor } from '../front-editor/front-editor';
import { SideEditor } from '../side-editor/side-editor';
import { TopEditor } from '../top-editor/top-editor';

const editors: Record<EditorSide, FC> = {
	[EditorSide.FRONT]: FrontEditor,
	[EditorSide.SIDE]: SideEditor,
	[EditorSide.TOP]: TopEditor,
};

export const Editor = () => {
	const { side } = useConfiguratorSide();
	const EditorComponent = editors[side];

	return (
		<EditorWrapper>
			<EditorComponent />
		</EditorWrapper>
	);
};
